<template>
  <div v-if="value && loaded">
    <div class="activeCover"></div>
    <OpaModal width="960" height="540" v-model="value" header="Selecione a Página">
      <div style="height:380px;overflow:auto; padding:20px;">
        <input type="text" v-model="searchTerm" class="inputText inputSearch" placeholder="Nome"
               style="float:left;height:30px"/>
        <div @click="searchTerm=null" style="float:left;margin-top:5px;cursor:pointer;">
          <OpaIcon name="broom" style="margin-left:5px;cursor:pointer"/>
        </div>
        <br/><br/>
        <table border="1" cellpadding="5" style="width:100%;border: 1px solid #ffffff;border-collapse:collapse;">
          <tr>
            <td>Selecione</td>
            <td>Nome</td>
          </tr>
          <tr v-for="(pages, idx) in filteredPages" v-bind:key="idx">
            <td style="text-align:center;">
              <template v-if="single">
                <input type="radio" style="width:30px;height:30px;" name="pagesRadio" :value="pages.id"
                       v-model="selectedPage"/>
              </template>
              <template v-else>
                <input type="checkbox" style="width:30px;height:30px;" name="pagesBox" v-model="pages.selected"/>
              </template>
            </td>
            <td>
              {{pages.page}}
            </td>
          </tr>
        </table>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:180px;float:right;margin:20px;margin-right:20px;" @click="$emit('selectPages', selectedPages()); clear(); $emit('close')">Selecionar</button>
        <button class="buttonWire" style="width:180px;float:right;margin:20px;margin-right:0px;" @click="clear(); $emit('close')">Cancelar</button>
      </div>
    </OpaModal>
  </div>
</template>

<script>
  import OpaModal from '@/components/OpaModal'
  import OpaIcon from '@/components/OpaIcon'
  import {EventBus} from '@/utils/event-bus'
  import {mapGetters} from 'vuex'
  import _ from 'lodash'

  export default {
    props: {
      single: Boolean,
      value: Boolean,
      previousSelectedNames: Array
    },

    data() {
      return {
        pages: [{id: 1, name: 'search', page: 'Busca'},
          {id: 2, name: 'offers', page: 'Ativar Ofertas'},
          {id: 3, name: 'history', page: 'Minhas Compras'},
          {id: 4, name: 'map', page: 'Área de Entrega'},
          {id: 5, name: 'contact', page: 'Contato'},
          {id: 6, name: 'cart', page: 'Meu Carrinho'}],
        modalPage: this.value,
        selectedPage: null,
        loaded: false,
        searchTerm: null
      }
    },

    watch: {
      value: function (a) {
        if (a) {
          // TODO improve this
          if (this.previousSelectedNames && this.previousSelectedNames.length && this.loaded) {
            this.pages.forEach((p) => {
              let f = this.previousSelectedNames.filter(pid => pid === p.id)
              if (f.length) {
                p.selected = true
                this.selectedPage = p.id
              }
            })
          } else {
            this.pages.forEach((p) => {
              p.selected = false
            })
            this.selectedPage = null
          }
        }
      }
    },

    components: {OpaModal, OpaIcon},

    async created() {
      this.modalPage = this.value
      EventBus.$emit('showLoading', true)
      EventBus.$emit('showLoading', false)
      this.loaded = true
    },

    computed: {
      ...mapGetters(['getProductApi']),

      filteredPages() {
        if (!this.searchTerm) {
          return this.pages
        } else {
          return _.union(
            this.pages.filter(p => p.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(this.searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) > -1),
          )
        }
      }
    },

    methods: {
      ...mapGetters(['getAdmin', 'getCompany']),

      clear() {
        this.pages.forEach(p => {
          p.selected = false
        })
      },

      selectedPages() {
        if (!this.single) {
          return this.pages.filter(p => p.selected)
        } else {
          return this.pages.filter(p => p.id === this.selectedPage)[0].name
        }
      }
    }
  }
</script>

<style lang="scss">
  .activeCover {
    height: auto;
    min-height: 100vh;
    width: 100vw;
    opacity: 0.49;
    background-color: #2A2531;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2900;
  }
</style>
